import type React from "react";

import { CheckIcon } from "@/components/Icons/CheckIcon";
import { Copy07Icon } from "@/components/Icons/Copy07Icon";
import { PageGrid } from "@/components/PageGrid/PageGrid";
import { SectionCard } from "@/design-system/SectionCard";
import { useTranslation } from "@/translations";

export type PortfolioBulkUploadAddressesSubmissionSummary = {
  amountCurrSubmitting: number; // Amount of rows being submitted in the current request
  amountSuccess: number; // Amount of rows rows successfully submitted in total
  amountDuplicates: number; // Amount of rows that were duplicates and skipped in total
  amountFailure: number; // Amount of rows that failed to submit in total (API failure or corrupted data)
};

interface BulkUploadAddressesSubmissionResultViewProps {
  submissionSummary: PortfolioBulkUploadAddressesSubmissionSummary;
}

export function BulkUploadAddressesSubmissionResultView({
  submissionSummary,
}: BulkUploadAddressesSubmissionResultViewProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <>
      <PageGrid.Column size="50%">
        <SectionCard
          icon={<CheckIcon />}
          title={t("page.portfolio-address-bulk-upload.section.valid-addresses-imported.title", {
            count: submissionSummary.amountSuccess,
          })}
          description={t("page.portfolio-address-bulk-upload.section.valid-addresses-imported.description")}
        />
      </PageGrid.Column>
      {submissionSummary.amountDuplicates > 0 && (
        <PageGrid.Column size="50%">
          <SectionCard
            icon={<Copy07Icon />}
            title={t("page.portfolio-address-bulk-upload.section.duplicate-addresses-skipped.title", {
              count: submissionSummary.amountDuplicates,
            })}
            description={t("page.portfolio-address-bulk-upload.section.duplicate-addresses-skipped.description")}
          />
        </PageGrid.Column>
      )}
    </>
  );
}
